import { render, staticRenderFns } from "./BulkPrintContainer.vue?vue&type=template&id=52d1bf31&scoped=true"
import script from "./BulkPrintContainer.vue?vue&type=script&lang=js"
export * from "./BulkPrintContainer.vue?vue&type=script&lang=js"
import style0 from "./BulkPrintContainer.vue?vue&type=style&index=0&id=52d1bf31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d1bf31",
  null
  
)

export default component.exports